import { useContext, useEffect, useMemo } from "react"
import { AppContext } from "Views/Home/context"
import { useAssign } from "Hooks/basic"
import { Annex, Material } from "Types/material"
import { DestructureObject } from "Methods/basic"
import { InitialModalSimple } from "Methods/modal"
import request from "Methods/request"
import { throttle } from "Methods/functions"

export function useDialog(modifyData: Material | null, handleConfirm: any, updatePrivilege = true, isBom: boolean) {
    const {
        title, projectName, link, authorName,
        originalLink, personInCharge, comment, summary, headImg,
        annexes, copyWriting, content, isUpload,
        isTiming, projectCode, isDraft,
    } = useInitialDialogData(modifyData)

    const { user } = useContext(AppContext)
    const { department, role } = user || {}
    const { type_name: departmentName } = department || {}
    const { role_name = '' } = role || {}
    let isMyPrincipal = false
    let isMine = false
    let isEditorOfEditPartment = false
    let isUser = false
    const isCreator = false
    if (user && modifyData) {
        isMine = user.uid === modifyData.creator_id
        isEditorOfEditPartment = ['side_editor', 'true_editor', 'op_editor'].includes(role_name)
        isMyPrincipal = user.uid === modifyData.principal.uid
        isUser = ['user'].includes(role_name)
    }
    const { handleChangeModalSimple } = useContext(AppContext)
    const {
        object: editData,
        handleChange,
    } = useAssign<Material | null>(null)
    useEffect(() => {
        handleChange(modifyData)
        // eslint-disable-next-line
    }, [modifyData])

    const onConfirm = (fieldName: string, text: any) => {
        handleChange({
            [fieldName]: text,
        })
    }
    const handleSubmit = (status = "") => {
        if (modifyData !== null) {
            let newData
            if (status) {
                newData = { ...modifyData, ...editData, ...{ status } }
            } else {
                newData = { ...modifyData, ...editData }
            }
            handleConfirm(newData)
        }
    }

    const handleGrab = throttle(async (filedName: string) => {
        const url = editData && editData[filedName as keyof Material]
        if (!url) {
            return
        }
        if (typeof (url) === 'string' && url.indexOf('weixin') < 0) {
            handleChangeModalSimple({
                show: true,
                title: "当前只能抓取微信文章链接下信息",
                timeout: 2000,
            })
            return
        }
        handleChangeModalSimple({
            show: true,
            title: "抓取中",
        })
        try {
            const { data } = await request.post("/apis/weixin/grab", {
                url
            })
            handleChange(data)
            handleChangeModalSimple(InitialModalSimple)
        } catch (error) {
            console.error(error)
            handleChangeModalSimple(InitialModalSimple)
            handleChangeModalSimple({
                show: true,
                title: "oops! 出错了",
                timeout: 2000,
            })
        }
    }, 1000)

    const { channel: { name = "" } = {} } = modifyData || {}
    const isWeibo = name === "微博"
    const isSpecies = name === "果壳自然"
    const isWechat = name === "微信"
    const isHealth = name === '果壳病人'
    // 保存按钮
    const disabled = useMemo(() => {
        if (!updatePrivilege) {
            return true
        }
        if (editData) {
            const newData = { ...modifyData, ...editData }
            if (isBom) {
                // 上传列表
                const isBusiness = departmentName === "business"
                if (isWeibo) {
                    const keys = ["copy_writing"]
                    if (isBusiness) {
                        keys.push("project_name")
                        keys.push("project_code")
                    }
                    return checkObjectValue(newData, keys)
                } else {
                    const keys = [
                        "title", "link",
                        "summary", "author_name", "content",
                    ]
                    if (isBusiness) {
                        keys.push("project_name")
                        keys.push("project_code")
                    }
                    return checkObjectValue(newData, keys) || !newData.head_img.url
                }
            } else {
                // 审查列表
                if (isUpload && !isUser) {
                    // 物料来源是上传列表
                    return !newData.content
                } else {
                    if (isWeibo) {
                        const keys = [
                            'copy_writing'
                        ]
                        const isBusiness = departmentName === "business"
                        if (isBusiness) {
                            keys.push("project_name")
                            keys.push("project_code")
                        }
                        return checkObjectValue(newData, keys)
                    } else {
                        const keys = [
                            "title", "link",
                            "summary", "author_name", "content",
                        ]
                        const isBusiness = departmentName === "business"
                        if (isBusiness) {
                            keys.push("project_name")
                            keys.push("project_code")
                        }
                        return checkObjectValue(newData, keys) || !newData.head_img.url
                    }
                }
            }
        } else {
            return true
        }
        // eslint-disable-next-line
    }, [editData])
    let isPass = false
    // 输入框禁用
    if (modifyData) {
        isPass = new Date(modifyData.ad_time).getTime() < new Date().setHours(0, 0, 0) - (24 * 3600 * 1000)
    }
    const inputDisabled = useMemo(() => {
        if (!updatePrivilege) {
            return true
        }
        if (modifyData) {
            const isDraft = modifyData.is_draft
            if (isPass && !isDraft) {
                return true
            } else if (!isBom) {
                // 点位运营单独判断
                // 合并物料页面后造成的冲突：http://taiga.iguokr.com/project/liyang-noah/us/2412?milestone=585
                if (role_name === 'user') {
                    return false
                }
                // 点位运营单独判断 -- END

                // 其他依旧保持原有状态
                return isUpload
            }
        } else {
            // TODO：物料合并后，这部分无用
            return true
        }
        // eslint-disable-next-line
    }, [modifyData])
    return {
        handleGrab,
        title, projectName, link, headImg,
        authorName, originalLink, personInCharge, comment, summary,
        disabled, annexes, isWeibo, copyWriting, isSpecies, isHealth,
        onConfirm, handleSubmit, inputDisabled,
        content, isUpload, isPass, isMine, isEditorOfEditPartment, isMyPrincipal,
        isTiming, departmentName, projectCode, isUser, isWechat,
        isDraft, ...DestructureObject(editData)
    }
}

const defaultDialogData = {
    title: "",
    projectName: "",
    projectCode: "",
    link: "",
    authorName: "",
    originalLink: "",
    personInCharge: "",
    comment: "",
    content: "",
    summary: "",
    copyWriting: "",
    annexes: [],
    headImg: {
        name: "",
        url: "",
    },
    isUpload: false,
    isTiming: false,
    isDraft: false,
}

// 初始化表单数据
function useInitialDialogData(initialData: Material | null) {
    return useMemo(() => {
        if (initialData) {
            const object: {
                id: number,
                title: string,
                content: string,
                link: string,
                headImg: {
                    name: string,
                    url: string,
                },
                status: string,
                summary: string,
                copyWriting: string
                projectName: string,
                projectCode: string,
                authorName: string,
                originalLink: string,
                personInCharge: string,
                comment: string,
                isTiming: boolean,
                isUpload: boolean,
                isDraft: boolean,
                adPlaceId: number,
                adTime: number,
                channelId: number,
                seqId: number,
                creatorId: string,
                annexes: Annex[],
                creator: {
                    uid: string,
                    nickname: string,
                    username: string,
                },
                adPlace: {
                    id: number,
                    name: string,
                    seq_num: number,
                },
                channel: {
                    name: string,
                },
            } = DestructureObject(initialData)
            return object
        } else {
            return defaultDialogData
        }
    }, [initialData])
}

function checkObjectValue(sourceData: any, checkKeys: string[]) {
    return checkKeys.some((key: string) => !sourceData[key])
}
